import Vue from 'vue'
import { confirm, alert, tip } from './pop'
export default function mixin () {
  Vue.mixin({
    methods: {
      $confirm: confirm,
      $alert: alert,
      $tip: tip
    }
  })
}



// WEBPACK FOOTER //
// ./src/mixin/index.js